import { Button } from "../common/button";
import { Input } from "../common/input";

export default function CTASection() {
  return (
    <div className="relative">
      <div className="mx-auto max-w-7xl py-12 px-6 sm:py-20">
        <div className="relative px-6 py-24 text-center sm:px-16">
          <h2 className="text-4xl font-bold tracking-tight text-white sm:text-5xl font-oxanium">
            Ready to Unlock the Talent in Your Network?
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-xl font-lato font-light text-white">
            Let’s show you how AIAURA Core works
          </p>
          <div className="mt-16 flex flex-col md:flex-row items-center justify-center gap-6">
            <Input />
            <Button classes={`relative z-20 text-nowrap text-base sm:text-xl font-semibold py-5 px-16 md:px-[34px] rounded-[15px] md:w-fit`} text="Schedule a Call" />
          </div>
          <img className="absolute -top-12 right-8 h-[700px]" src="/circle2.png" alt="" />
        </div>
      </div>
      <img className="absolute top-0 right-8 max-h-[300px] w-full" src="/cta_background.png" alt="" />
    </div>
  )
}
